/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { Field as a } from "./Field.mjs";
import { Form as o } from "./Form.mjs";
import { FieldArray as l } from "./FieldArray.mjs";
import { FieldWrapper as d } from "./FieldWrapper.mjs";
import { FormElement as n } from "./FormElement.mjs";
import { withIdHOC as r } from "@progress/kendo-react-common";
const e = r(o);
e.displayName = "KendoReactForm";
export {
  a as Field,
  l as FieldArray,
  d as FieldWrapper,
  e as Form,
  o as FormClassComponent,
  n as FormElement
};
